<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 8.88867C10.2091 8.88867 12 7.09781 12 4.88867C12 2.67953 10.2091 0.888672 8 0.888672C5.79086 0.888672 4 2.67953 4 4.88867C4 7.09781 5.79086 8.88867 8 8.88867Z"
      stroke="#2B303A"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.1109 15.1112V14.3792C15.1109 13.6026 14.7363 12.9624 14.0695 12.4133C13.4027 11.8642 12.4983 11.5557 11.5553 11.5557H4.44423C3.50124 11.5557 2.59687 11.8642 1.93007 12.4133C1.26327 12.9624 0.888672 13.6026 0.888672 14.3792V15.1112"
      stroke="#2B303A"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
  export default {
    name: 'UserIcon',
  };
</script>

